module.exports = __webpack_public_path__ + "img/logo.48e8fe34.png";